import { render, staticRenderFns } from "./index.vue?vue&type=template&id=52b56d65&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DatePicker: require('/home/runner/work/myody_front/myody_front/components/date/DatePicker.vue').default,FormItem: require('/home/runner/work/myody_front/myody_front/components/form/FormItem.vue').default,Form: require('/home/runner/work/myody_front/myody_front/components/form/Form.vue').default,RadioOptions: require('/home/runner/work/myody_front/myody_front/components/radio/RadioOptions.vue').default,GoodsOdyList: require('/home/runner/work/myody_front/myody_front/components/goods/GoodsOdyList.vue').default,Card: require('/home/runner/work/myody_front/myody_front/components/card/Card.vue').default,Col: require('/home/runner/work/myody_front/myody_front/components/col/Col.vue').default,RadioButton: require('/home/runner/work/myody_front/myody_front/components/radio/RadioButton.vue').default,RadioGroup: require('/home/runner/work/myody_front/myody_front/components/radio/RadioGroup.vue').default,ListLabel: require('/home/runner/work/myody_front/myody_front/components/list/ListLabel.vue').default,ListLabelItem: require('/home/runner/work/myody_front/myody_front/components/list/ListLabelItem.vue').default,Row: require('/home/runner/work/myody_front/myody_front/components/row/Row.vue').default})
